import React from 'react'

const OPTDealerResponse = () => {
    return (
        <>
            <div className='component__modal_window_homeLoan component__settings component__popCSS'>
                <div className='component__mwBody component__settings'>
                    <div className='pageComponent opt_compbody'>
                        <ul className='tabs__maintabs tabs__settings'>
                            <li className='pageComponent component__settings'>Opt out Dealer Response</li>
                            <li className='pageComponent component__settings'>Settings for My Leads</li>
                            <li className='pageComponent component__settings'>Change Password</li>
                        </ul>
                        <div className='pageComponent dashboard__content'>
                            <div className='dashboard__content'>
                                <h4>Opt out Dealer Response</h4>
                                <span>You can choose to not receive responses we have identified as dealers.
                                    Please note that dealers will still be able to call you or query on your property,
                                    you simply will not see them
                                </span>
                            </div>
                            <div className='dashboard__content'>
                                <h4>Don't send me response via</h4>
                                <ul className='dashboard__checkboxlist'>
                                    <li>
                                        <div>
                                            <div className='undefinedContainer'>
                                                <div>
                                                    <input type="checkbox" name='checed' id='0' />
                                                    <span style={{ paddingLeft: "5px" }}>SMS</span>
                                                </div>
                                                <div>
                                                    <input type="checkbox" name='checed' id='1' />
                                                    <span style={{ paddingLeft: "5px" }}>Emails</span>
                                                </div>
                                                <div>
                                                    <input type="checkbox" name='checed' id='1' />
                                                    <span style={{ paddingLeft: "5px" }}>Mygoldenhomes</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className='opt_dealerdashboard__buttonWrapper' style={{ display: "flex", marginTop: "20px" }}>
                                    <div className='opt_dealerdashboard__ngdialogButtonPrimary opt_dealerdashboard__ngdialogButton' style={{ width: '35%', marginRight: "10%" }}>
                                        <span><input type="button" value="Submit" /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OPTDealerResponse